import './NewsletterProduct.scss'

import {
	FieldsubmitField,
	FieldsubmitRow,
	FieldsubmitSubmit
} from '../../ui/Fieldsubmit'
import {FormField, FormFields, Input, Label} from '../../layout/Form'
import {FormProvider, useForm} from 'react-hook-form'
import React, {useState} from 'react'
import {useLanguage, useTranslation} from '../../../util/i18n'

import {Errors} from '../../layout/form/Errors'
import {Theme} from '../../Theme'
import {WysiwygType} from '../../../types'
import {fetcher} from '../../../util/fetcher'
import {style} from '../../../util/style'

const styles = style('newsletterproduct', ['form'])

export type NewsletterProductType = {
	text?: WysiwygType
	productId: number
	submit?: string
}

export const NewsletterProduct: React.FC<NewsletterProductType> = ({
	text,
	submit,
	productId
}) => {
	return (
		<div id="newsletterproduct" className={styles()}>
			{text && (
				<div className={styles('text')}>
					<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
				</div>
			)}
			<NewsletterProductNotifyForm productId={productId} submit={submit} />
		</div>
	)
}

const NewsletterProductNotifyForm: React.FC<{
	submit?: string
	productId: number
}> = ({submit, productId}) => {
	const t = useTranslation('webshop').products.notify
	const methods = useForm()
	const {handleSubmit, setError} = methods
	const lang = useLanguage()
	const [isSending, setIsSending] = useState(false)
	const [isSubmitted, setIsSubmitted] = useState(false)
	const onSubmit = (data, e) => {
		e.preventDefault()
		setIsSending(true)
		fetcher(`/api/notifywheninstock?productid=${productId}&language=${lang}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})
			.then((res) => {
				setIsSending(false)
				setIsSubmitted(true)
			})
			.catch((errors) =>
				Object.entries(errors).forEach(
					([field, messages]: [string, Array<string>]) => {
						return messages.forEach((m) => {
							setError(field, {type: 'validate', message: m})
						})
					}
				)
			)
	}

	const fieldsubmit = {
		type: 'email',
		name: 'email',
		id: 'newsletterproduct_email',
		label: 'E-mail'
	}

	return (
		<FormProvider {...methods}>
			{!isSubmitted ? (
				<form onSubmit={handleSubmit(onSubmit)} className={styles.form()}>
					<FieldsubmitRow>
						<FieldsubmitField>
							<Label
								htmlFor={fieldsubmit.id || fieldsubmit.name}
								label={fieldsubmit.label}
							/>
							<Input
								{...fieldsubmit}
								id={fieldsubmit.id || fieldsubmit.name}
								required
							/>
						</FieldsubmitField>
						<FieldsubmitSubmit>
							<Theme.Button loading={isSending} as="button" mod="boldtext">
								{submit || 'Submit'}
							</Theme.Button>
						</FieldsubmitSubmit>
					</FieldsubmitRow>
					<FormFields>
						<FormField
							amount={null}
							type="checkbox"
							name="newsletter"
							label={t.newsletter}
						/>
					</FormFields>
					<Errors />
				</form>
			) : (
				<Theme.P>{t.submitted}</Theme.P>
			)}
		</FormProvider>
	)
}
